import { AvisToastMessage, IAvisToastMessageProps } from "./AvisToastMessage";

export function AvisToastMessageInfo(props: Readonly<IAvisToastMessageProps>) {
  const { severity = "info", ...restProps } = props;

  return <AvisToastMessage {...restProps} severity={severity} />;
}
